import { UcoastEl } from '@/scripts/core/UcoastEl'
import { getAttributeOrThrow, qsRequired } from '@/scripts/core/global'

export class BlueBird extends UcoastEl {
	static htmlSelector = 'blue-bird'
	iframe?: HTMLIFrameElement
	container: HTMLElement
	placeholder: HTMLElement
	handle: string
	constructor() {
		super()
		this.handle = getAttributeOrThrow('data-handle', this)
		this.container = qsRequired('.bluebird', this)
		this.placeholder = qsRequired('#blueBirdFrame', this)
	}
	load = () => {
		const src = this.handle.includes('avant')
			? 'https://app.bluebirdclimate.com/embed/experiment/oDqRUhn8s9Z8XRw6d1Isp5RIiyYDJZ6S38zl0POwfASUDagpqF_ulG8C98XQ0NWT'
			: this.handle.includes('super')
			? 'https://app.bluebirdclimate.com/embed/experiment/sjmAWR_8p8JpWgonUEI7r6ZUljMAJZyaydzb3PemXBWiYSjccHCGJHEuHixtR0BNOXWjcQ'
			: this.handle.includes('softwear')
			? 'https://app.bluebirdclimate.com/embed/experiment/um6FSQS19pk_HUl0FxE64JQM3H5Yfd_PmoSFmLu8PED_b2mbW37QBXTjwzpu7CzYnFDMyxP8-PtbEdgzTz5U5muob26OAXZyFNPu4OGPGXA5CcKDVdrXKK-d2_lrTPk'
			: this.handle.includes('plasma')
			? 'https://app.bluebirdclimate.com/embed/experiment/um6FSQS19pk_G0B-ExJq65YM1XBYL9_PyoPSmOHoPkn_bDybUSjbUHSxyzFq7CzYnFDMyxP8-PtbEdgzTz5U5muob26OAXZyFNPu4OGPGXqFiyeK3pvx4FlebHR-pP0'
			: this.handle.includes('molecular')
			? 'https://app.bluebirdclimate.com/embed/experiment/um6FSQS19pk_TEsjQERoscUMhCNSdN_PyYOHmOLqPUj_N22aX3_eAiW3mGxq7CzYnFDMyxP8-PtbEdgzTz5U5muob26OAXZyFNPu4OGPGW3IgdUbNXtOP3gnNDcvPUs'
			: 'https://app.bluebirdclimate.com/embed/experiment/ozmWWgij-cl4QxQ_WHQqoIFAjCkALpuXwsHO5-avYQKm0w_O2xUTreDrotc4hpYwkg'
		try {
			this.iframe = document.createElement('iframe')
			this.iframe.src = src
			this.iframe.dataset.test = 'embedded-widget'
			this.iframe.loading = 'lazy'
			this.iframe.scrolling = 'no'
			this.iframe.frameBorder = '0'
			this.iframe.style.border = '0'
			//this.iframe.allowTransparency = true;
			this.container.replaceChild(this.iframe, this.placeholder)
		} catch (e) {
			console.error(e)
			this.iframe = undefined
		}
	}
}
